"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { ProjectBrowserContent } from "#/features/project/ui/ProjectBrowser/ProjectBrowserContent";
import { useI18nContext } from "#/shared/hooks";
import { useMobilePlaygroundView } from "../hooks/useMobilePlaygroundView";
export const MobileBrowseView: React.FC = () => {
  const $ = _c(13);
  const {
    LL
  } = useI18nContext();
  const {
    goToCode
  } = useMobilePlaygroundView();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      height: "100%",
      display: "flex",
      flexDirection: "column"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      px: 2,
      pt: 1.5,
      pb: 1
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontWeight: 600
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== LL) {
    t3 = LL.PROJECT_BROWSER();
    $[3] = LL;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Box sx={t1}><Typography variant="h6" component="h2" sx={t2}>{t3}</Typography></Box>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== goToCode) {
    t6 = <ProjectBrowserContent onSelectProject={goToCode} />;
    $[8] = goToCode;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <Stack sx={t0}>{t4}{t5}{t6}</Stack>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};